import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { Text } from "../."
import { StyledButton } from "../buttons"
import { BackIcon } from "../icons"
import { Header } from "../other"
import { Title } from "../typography"

export const ProfileHeader = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()

	return (
		<Header
			left={
				<StyledButton onClick={() => navigate("/")} style="flex flex-row items-center">
					<BackIcon />
					<Text style="ml-[5px]">{t("profile.back")}</Text>
				</StyledButton>
			}
			center={<Title>{t("profile.profile")}</Title>}
		/>
	)
}
